export const formatsReactQuill = [
  "header",
  "bold", "italic", "underline", "strike",
  "list",                 // <-- ТІЛЬКИ "list", без "bullet"
  "blockquote", "code-block",
  "color", "background",
  "align",
  "link", "image",
  "softbreak",            // Shift+Enter → <br class="ql-softbreak">
  // quill-table-better formats
  "table-container", "table-body", "table-row", "table-cell", "table-cell-block",
  "table-th", "table-th-block", "table-th-row", "table-thead",
  "table-col", "table-colgroup", "table-temporary",
  "table-header", "table-list", "table-list-container",
];
